export default __webpack_public_path__ + "static/media/price.63acf763.png";